// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__17gvq","footer":"NavbarSimple_footer__rvdA0","link":"NavbarSimple_link__SidpO","linkIcon":"NavbarSimple_linkIcon__f2LXD"};